import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/pages/home/home.component';


const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'join',
    pathMatch: 'full'
  },
  {
    path: 'home',
    redirectTo: 'join',
  },
  {
    path: '**',
    redirectTo: 'join'
  }
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(appRoutes, { useHash: false })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
